module.exports = __webpack_public_path__ + "img/new_dawn.513f770c.jpg";